import { createSlice } from "@reduxjs/toolkit";

const bookingsSlice = createSlice({
  name: "bookings",
  initialState: {
    bookingsList: {
      data: [],
      total: 0,
    },
  },
  reducers: {
    setBookingsList: (state, action) => {
      state.bookingsList = action.payload;
    },
  },
});

export const { setBookingsList } = bookingsSlice.actions;
export default bookingsSlice.reducer;